module.exports = __webpack_public_path__ + "img/生态基地2.dfb1f965.png";